'use es6';

import Languages from '../constants/Languages';
var DEFAULT_LANGUAGE = 'en';
export default {
  isLanguageSupported: function isLanguageSupported(language) {
    return Object.keys(Languages).indexOf(language) >= 0;
  },

  /**
   * E.g. de, en, es (default is en)
   */
  getUserLanguage: function getUserLanguage() {
    var userLanguage = window.I18N_MANUAL_LANG;
    return this.isLanguageSupported(userLanguage) ? userLanguage : DEFAULT_LANGUAGE;
  },

  /**
   * E.g. Deutsch, English, Español
   */
  getPrintUserLanguage: function getPrintUserLanguage() {
    var userLanguage = this.getUserLanguage();
    return Languages[userLanguage];
  }
};